import Vue from 'vue'
import Vuex from 'vuex'
// import router from './../router'

import auth from './modules/auth'
import applicationsapi from './modules/applicationsapi'
import menuitems from './modules/menuitems'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    auth,
    applicationsapi,
    menuitems
  },
  strict: true,
  state: {
    baseurl: 'https://application.sadcseedcentre.com/api/web/v1/',
    submissiondetails: {
      applnumber: null,
      country: null
    },
    attachmentdetails: {
      applnumber: null
    },
    userdetaildata: {
      country: 'Zambia'
    }
  },
  mutations: {
    setUserdetaildata (state, userDetaildata) {
      state.userdetaildata.country = userDetaildata.country
    }
  },
  actions: {
    setUserdetaildata ({commit}, userDetaildata) {
      commit('setUserdetaildata', userDetaildata)
    }
  },
  getters: {
    getBaseurl (state) {
      return state.baseurl
    },
    getRoute (state) {
      return state.route.name
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js